<template>
  <div class="btn-yellow">
    <a :href="url">
      <mdicon name="PagePreviousOutline" class="flex justify-center text-white" size="90" />
      <h2 class=" text-white text-xl text-center font-semibold mb-4">{{ title }}</h2>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: 'https://psp.duquedecaxias.rj.gov.br/portal/form.jsp?sys=PSP&action=openform&formID=8274'
    }
  },
  props: {
    title: String
  },
}
</script>
